import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  number: number;
  question: string;
  answer: string;
}
function FAQItem({
  number,
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-[#141414] border border-[#2a2a2a] rounded-xl overflow-hidden" data-id="element-4">
      <button className="w-full py-4 px-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-5">
        <div className="flex items-center gap-3" data-id="element-6">
          <span className="text-[#22c55e] font-bold text-sm" data-id="element-7">{number} —</span>
          <span className="font-bold text-white text-sm md:text-base" data-id="element-8">
            {question}
          </span>
        </div>
        {isOpen ? <ChevronUp className="h-4 w-4 text-[#22c55e] flex-shrink-0 ml-2" data-id="element-9" /> : <ChevronDown className="h-4 w-4 text-gray-500 flex-shrink-0 ml-2" data-id="element-10" />}
      </button>
      {isOpen && <div className="px-5 pb-4 text-gray-400 text-sm leading-relaxed ml-8" data-id="element-11">
          {answer}
        </div>}
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Cómo recibo el Kit después de comprar?',
    answer: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos ya tenés todo descargado en tu dispositivo. 100% PDF, sin apps ni plataformas extras.'
  }, {
    question: '¿Sirve para mi provincia o solo para Buenos Aires?',
    answer: 'Sirve para todo el país. Los contenidos están alineados con los Núcleos de Aprendizaje Prioritarios (NAP) y son adaptables a cualquier diseño curricular provincial.'
  }, {
    question: '¿Es editable? ¿Puedo modificarlo?',
    answer: 'El material viene en PDF listo para usar. Podés imprimirlo, proyectarlo o compartirlo digitalmente. Si necesitás adaptar algo, podés copiar el texto y pegarlo en tu propio documento.'
  }, {
    question: '¿Los 3 bonos están en todas las ofertas?',
    answer: 'Sí. Los 3 bonos estratégicos están incluidos en ambas opciones de compra, sin costo adicional.'
  }, {
    question: '¿Puedo comprar solo el Kit básico ahora y después el completo?',
    answer: 'Sí, podés empezar con el Kit Filosofía Lista y luego actualizar al Kit Completo. Pero te recomendamos aprovechar el precio de lanzamiento del Kit Completo porque después sube.'
  }, {
    question: '¿Funciona si mis alumnos no tienen interés en Filosofía?',
    answer: 'Justamente para eso está diseñado. Las actividades están pensadas para captar la atención de alumnos que no se enganchan fácilmente, con dinámicas, juegos y situaciones cotidianas que conectan con la Filosofía.'
  }, {
    question: '¿Sirve para cursos difíciles o con mucho desorden?',
    answer: 'Sí. Las secuencias están diseñadas para mantener la atención y generar participación. Muchos docentes nos cuentan que con este material logran clases más ordenadas y productivas.'
  }, {
    question: '¿Está actualizado al currículo vigente?',
    answer: 'Sí. Todo el material está alineado con los contenidos curriculares vigentes para Filosofía en el nivel secundario argentino, incluyendo la planificación anual 2026.'
  }, {
    question: '¿Tiene garantía real?',
    answer: 'Sí. Tenés 7 días para probarlo. Si no te sirve, te devolvemos el 100% del dinero sin hacerte ninguna pregunta. Cero riesgo.'
  }, {
    question: '¿Qué diferencia tiene el Kit con otros materiales que vi?',
    answer: 'Este no es un PDF suelto ni un banco de actividades genérico. Es un sistema completo y organizado que cubre todo el año: secuencias, actividades, evaluaciones, planificación y recursos extras. Todo pensado específicamente para Filosofía en secundario.'
  }];
  return <div className="space-y-3" data-id="element-12">
      {faqs.map((faq, index) => <FAQItem key={index} number={index + 1} question={faq.question} answer={faq.answer} data-id="element-13" />)}
    </div>;
}